module.exports = __webpack_public_path__ + "static/media/PrivateHookah_main_p.868318c3.jpg";